import React from "react";
import { createHead, createCells } from "./restoreConfigsTableHandler";
import styles from "../../pages/JobDetails/Jobdetails.module.css";
import DynamicTable from "@atlaskit/dynamic-table";
const TableWrapper = ({ children }) => (
  <div className={styles.restoreissuesjobdetailstablewrapper}>{children}</div>
);
const RestoreConfigJobDetails = ({ restoreConfigDetails, isLoading }) => {
  const rows = createCells(restoreConfigDetails ? restoreConfigDetails : []);
  const head = createHead();
  return (
    <TableWrapper>
      <DynamicTable
        head={head}
        rows={rows}
        rowsPerPage={undefined}
        defaultPage={1}
        loadingSpinnerSize="large"
        isLoading={isLoading}
        emptyView={<strong>No data found</strong>}
      />
    </TableWrapper>
  );
};

export default RestoreConfigJobDetails;
